import React from 'react'

function InputWithCounter(props) {
    let count   = props.count.length;
    let max     = props.maxlength;

  return (
    <div className='content-input-with-counter'>
        <input 
            type="text" 
            className='form-control text-filter__form-control' 
            {...props} 
        />
        <span className={((count >= max) ? "text-danger" : "" )+ " font-weight-bold counter"}>
            {count}
        </span>
    </div>
  )
}

export default InputWithCounter